var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import NestedRoute from "./NestedRoute";
import PartialRoute from "./PartialRoute";
export default function (Component, nestedProps, componentProps) {
    return withRoute(Component, nestedProps, componentProps, NestedRoute);
}
export function withPartialRoute(Component, nestedProps, componentProps) {
    return withRoute(Component, nestedProps, componentProps, PartialRoute);
}
function withRoute(Component, nestedProps, componentProps, RouteComponent) {
    return function (props) {
        var path = "" + (props.match || "") + (props.path || "");
        return React.createElement(RouteComponent, __assign({}, props, nestedProps, { path: path, component: Component, componentProps: __assign(__assign({}, componentProps), { path: path }) }));
    };
}
